import { type FC, useMemo } from "react";

import { buildMarketChips } from "~/feature/chart/utils";
import type { IMarket } from "~/types/event";

import { MarketChip } from "./components/MarketChip";
import * as Styled from "./MarketChips.styles";

interface IMarketChipsProps {
  markets: IMarket[];
  selections: string[];
  onToggle: (marketId: string) => void;
}

export const MarketChips: FC<IMarketChipsProps> = ({
  markets,
  selections,
  onToggle,
}) => {
  const chips = useMemo(
    () => buildMarketChips(markets, selections),
    [markets, selections]
  );
  const isRemovable = chips.length > 1;

  return (
    <Styled.Root>
      {chips.map(({ key, title, platform, isWholeMarket, marketIds }) => (
        <MarketChip
          key={key}
          title={title}
          platform={platform}
          isWholeMarket={isWholeMarket}
          onRemove={
            isRemovable
              ? () => marketIds.forEach((id) => onToggle(id))
              : undefined
          }
        />
      ))}
    </Styled.Root>
  );
};
